import React, { useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Autocomplete } from '@mui/material';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import addCommas from '../../utils/functions/commas';
import { LinearProgress } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles'; // 1. ต้อง import 'styled'
import _ from 'lodash';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff', // หรือ theme.palette.action.hover ถ้าต้องการ
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },

  // [ปรับปรุง] ย้าย :hover มาไว้ที่นี่
  '&:hover': {
    
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer', // เพิ่ม cursor เพื่อให้รู้ว่า hover ได้
  },


  transition: 'transform 0.15s ',
}));

function SearchBankAndTableMatch({
  refreshKey = 0,
  setInvoicesDataBank,
  isFetchingBank,
  setIsFetchingBank,
  matchButtonApi,
  calculateTotalAmount,
  t,
}) {
  const latestRequest = useRef(0);
  useEffect(() => () => { latestRequest.current += 1; }, []);
  const [loading, setLoading] = useState(false);
  const [selectedItemsBank, setSelectedItemsBank] = useState([]);
  const [startDate, setStartDate] = useState(
    dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
  );
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [selectStatus, setSelectStatus] = useState('');
  const [bankData, setBankData] = useState([]);
  const [groupBank, setGroupBank] = useState('');
  const [totalTHB, setTotalTHB] = useState('');
  const [selectBank, setSelectBank] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchStatement, setSearchStatement] = useState('');
  const [sortBy, setSortBy] = useState('transaction_date');
  const [sortOrder, setSortOrder] = useState('desc');

  useEffect(() => {
    if (selectedItemsBank) {
      setInvoicesDataBank(selectedItemsBank);
    }
  }, [selectedItemsBank]);

  const handleTotal = (event) => {
    setTotalTHB(event.target.value);
  };

  const handleClear = () => {
    setStartDate(
      dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
    );
    setEndDate(dayjs().format('YYYY-MM-DD'));
    setTotalTHB('');
    setSelectStatus('');
    setSearchStatement('');
  };

  const handleStatusCheckBox = (event) => {
    if (event.target.checked) {
      setSelectStatus(event.target.value);
    } else {
      setSelectStatus('');
    }
  };
  const handleStartDateChange = (newValue) => {
    setStartDate(newValue ? dayjs(newValue).format('YYYY-MM-DD') : null);
  };

  const handleEndDateChange = (newValue) => {
    setEndDate(newValue ? dayjs(newValue).format('YYYY-MM-DD') : null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value, 10);
    setPage(0);
  };

  const SearchBankData = async (requestedPage = page) => {
    const requestId = ++latestRequest.current;
    setIsFetchingBank(true);
    try {
      setLoading(true);
      const bookbank =
        selectBank?.bank_name && selectBank?.account_no
          ? `${selectBank.bank_name}-${selectBank.account_no}`
          : undefined;

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_admin}/matchstatement/bank-statement`,
        {
          params: {
            page: requestedPage + 1,
            size: rowsPerPage,
            bookbank,
            totals: totalTHB || undefined,
            start_date: startDate,
            end_date: endDate,
            status: selectStatus || undefined,
            keyword: searchStatement || undefined,
            sortBy,
            sortOrder,
          },
        },
      );

      if (requestId !== latestRequest.current) return;
      const data = response?.data.data[0];
      setTotal(data?.metadata[0]?.total || 0);
      setBankData(data?.data);
    } catch (error) {
      if (requestId === latestRequest.current) {
        console.error('Error fetching data:', error);
        setBankData([]);
        setTotal(0);
      }
    } finally {
      if (requestId === latestRequest.current) {
        setLoading(false);
        setIsFetchingBank(false);
      }
    }
  };

  const handleSearch = () => {
    setPage(0);
    SearchBankData(0);
  };

  const handleSortRequested = (columnId) => {
    setPage(0);
    setSortOrder((prevOrder) =>
      sortBy === columnId ? (prevOrder === 'asc' ? 'desc' : 'asc') : 'asc',
    );
    setSortBy(columnId);
  };

  useEffect(() => {
    if (startDate && endDate) {
      SearchBankData();
    }
  }, [page, rowsPerPage, sortBy, sortOrder, refreshKey]);

  useEffect(() => {
    setSelectedItemsBank([]);
  }, [refreshKey]);

  useEffect(() => {
    const fetchGroupBank = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_admin}/matchstatement/group-bank-acc`,
        );
        const dataGroupBank = response?.data.data;

        setGroupBank(dataGroupBank);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchGroupBank();

    // Cleanup function
  }, []);

  const handleCheckboxChange = (event, row) => {
    if (event.target.checked) {
      setSelectedItemsBank([row]);
    } else {
      setSelectedItemsBank([]);
    }
  };

  const isSelected = (row) => selectedItemsBank.includes(row);

  const customCellHeader = {
    whiteSpace: 'nowrap',
    backgroundColor: '#4caf50',
    color: 'white',
    padding: '10px',
    fontWeight: 'bold',
    fontSize: '13px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  };

  const customCellBankData = {
    whiteSpace: 'nowrap',
    fontSize: '12px',
    borderBottom: '1px solid #e0e0e0',
  };

  const sortLabelSx = {
    color: '#fff !important',
    '& .MuiTableSortLabel-icon': {
      color: '#fff !important',
    },
  };

  const bankColumns = [
    { id: 'statement_ref', label: t('app.statementRef') },
    { id: 'bookbank', label: t('app.bookbankNoStatment') },
    { id: 'transaction_date', label: t('app.dateTime') },
    { id: 'amount', label: t('app.totalMatch') },
    { id: 'balance', label: t('app.balance') },
    { id: 'status', label: t('app.status') },
    { id: 'description', label: t('app.description') },
    { id: 'detail_status', label: t('app.detailStatus') },
  ];

  return (
    <div className="">
      {' '}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 border-2 border-gray-300 xl:h-[300px] p-5">
        <div className=" ">
          {' '}
          {t('app.bookbookbankNo')}
          <div>
            <Autocomplete
              options={groupBank}
              getOptionLabel={(option) =>
                `${option.bank_name}-${option.account_no}`
              }
              onChange={(event, newValue) => {
                setSelectBank(newValue);
                // console.log('Selected customer:', newValue);
              }}
              disablePortal
              size="small"
              id="combo-box-demo"
              sx={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={t('app.selectBankAccount')}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBalanceIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </div>
        </div>

        <div>
          {t('app.total')}
          <div>
            <TextField
              value={totalTHB}
              placeholder="THB"
              id="outlined-basic"
              size="small"
              onChange={handleTotal}
              sx={{ width: '100%', backgroundColor: '#FFFFFF' }}
            />
          </div>
        </div>
        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={t('app.depositDate')}
              value={startDate ? dayjs(startDate) : null}
              onChange={handleStartDateChange}
              format="DD/MM/YYYY"
              views={['year', 'month', 'day']}
              slotProps={{
                textField: {
                  size: 'small',
                  sx: { width: '100%' },
                },
              }}
            />
          </LocalizationProvider>{' '}
        </div>

        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={t('app.toDate')}
              format="DD/MM/YYYY"
              value={endDate ? dayjs(endDate) : null} // ✅ แปลงค่าเป็น dayjs
              onChange={handleEndDateChange}
              views={['year', 'month', 'day']}
              slotProps={{
                textField: {
                  size: 'small',
                  sx: { width: '100%' },
                },
              }}
            />
          </LocalizationProvider>
        </div>

        {/* status----------------------------- */}
        <div>
          <div className="flex gap-4">
            <div className="flex flex-col items-center">
              <Checkbox
                checked={selectStatus === 'All'}
                onChange={handleStatusCheckBox}
                value="All"
              />
              <div className="text-sm">{t('app.all')}</div>
            </div>

            <div className="flex flex-col items-center">
              <Checkbox
                checked={selectStatus === 'Match'}
                onChange={handleStatusCheckBox}
                value="Match"
              />
              <div className="text-sm">{t('app.match')}</div>
            </div>

            <div className="flex flex-col items-center">
              <Checkbox
                checked={selectStatus === 'Unmatch'}
                onChange={handleStatusCheckBox}
                value="Unmatch"
              />
              <div className="text-sm">{t('app.unmatch')}</div>
            </div>

            <div className="flex flex-col items-center">
              <Checkbox
                checked={selectStatus === 'Partial'}
                onChange={handleStatusCheckBox}
                value="Partial"
              />
              <div className="text-sm">{t('app.partial')}</div>
            </div>
          </div>
        </div>

        <div>
          {' '}
          {t('app.search')}
          <div>
            <TextField
              value={searchStatement}
              variant="outlined"
              sx={{ width: '100%' }}
              size="small"
              placeholder={t('app.descriptionStatementRef')}
              onInput={(e) => setSearchStatement(e.target.value)}
            />
          </div>
        </div>

        <div className="flex flex-row justify-end xl:col-start-2">
          <div>
            <Button onClick={handleSearch} variant="outlined">
              {t('app.search')}
            </Button>
            {loading && <LinearProgress color="inherit" />}
          </div>
          <div className="ml-2">
            <Button variant="outlined" color="error" onClick={handleClear}>
              {t('app.clear')}
            </Button>
          </div>
        </div>
      </div>
      {/* {Table} */}
      <div className="mt-5 border-2   ">
        <div>
          <TableContainer
            sx={{
              maxHeight: 330,
              overflow: 'auto',
              backgroundColor: 'white',
              position: 'relative',
            }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  {bankColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="center"
                      sx={customCellHeader}
                    >
                      <TableSortLabel
                        active={sortBy === column.id}
                        direction={sortBy === column.id ? sortOrder : 'asc'}
                        onClick={() => handleSortRequested(column.id)}
                        sx={sortLabelSx}
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {isFetchingBank ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : _.size(bankData) ? (
                  bankData.map((row, index) => (
                    <StyledTableRow key={index}>
                      <TableCell align="center" sx={customCellBankData}>
                        <Checkbox
                          onChange={(event) => handleCheckboxChange(event, row)}
                          checked={isSelected(row)}
                        />
                        <span className="ml-2">{row.statement_ref}</span>
                      </TableCell>

                      <TableCell align="center" sx={customCellBankData}>
                        {row.bank} {row.account_no}
                      </TableCell>

                      <TableCell align="center" sx={customCellBankData}>
                        {dayjs(row.transaction_date).format(
                          'YYYY MMMM DD HH:mm:ss',
                        )}
                      </TableCell>

                      <TableCell align="center" sx={customCellBankData}>
                        {addCommas(row.amount)}
                      </TableCell>

                      <TableCell align="center" sx={customCellBankData}>
                        {addCommas(row.balance)}
                      </TableCell>

                      <TableCell align="center" sx={customCellBankData}>
                        {row.status}
                      </TableCell>

                      <TableCell align="center" sx={customCellBankData}>
                        {row.description}
                      </TableCell>

                      <TableCell align="center" sx={customCellBankData}>
                        {row.detail_status || '-'}
                      </TableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography color="text.secondary">
                        ไม่มีข้อมูล
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      <div className="flex flex-col xl:hidden mt-5">
        <div className="font-bold ">
          {t('app.totalSelectedAmount')}: {addCommas(calculateTotalAmount())}{' '}
          THB
        </div>
        <div className="mt-5 flex justify-center ">
          <Button
            variant="contained"
            sx={{ color: 'white' }}
            onClick={matchButtonApi}
          >
            {t('app.matching')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SearchBankAndTableMatch;
